export default (value, { items, initialValue }) =>
  value !== initialValue &&
items.some(l => l.name === (value || '').trim()) ?
    'This name is in use already' : null
